import React from 'react';

export default function Error404Page() {
  return <>404 page placeholder</>;
}
